import { render, staticRenderFns } from "./LoadingInfiniteMessage.vue?vue&type=template&id=b0e4c11c&scoped=true"
import script from "./LoadingInfiniteMessage.vue?vue&type=script&lang=js"
export * from "./LoadingInfiniteMessage.vue?vue&type=script&lang=js"
import style0 from "./LoadingInfiniteMessage.vue?vue&type=style&index=0&id=b0e4c11c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e4c11c",
  null
  
)

export default component.exports